const ESSANO_OKENDO_API_URL = 'https://api.okendo.io/v1';

function essanoCreateOkendoApi(subscriberId) {
    const createQueryString = (params) => {
        return Object.keys(params).map(key => {
            return `${key}=${encodeURIComponent(params[key])}`;
        }).join('&');
    };

    return {
        getProductReviews: function(productId, options = {}) {
            const defaultOptions = {
                limit: 20,
                orderBy: 'has_media desc',
                locale: 'en',
                ...options
            };
            
            const queryString = createQueryString(defaultOptions);
            const url = `${ESSANO_OKENDO_API_URL}/stores/${subscriberId}/products/shopify-${productId}/reviews?${queryString}`;
            
            return fetch(url, {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            });
        }

    };
}

function essanoCreateReviewHTML(review, readMoreText = 'Read More', productId = '', writeReviewText = 'Write Review', headingText = '', writeReviewUrl = '', readLessText = 'Read Less', truncateLength = 140, slideIndex = 0) {
    const { title, body, reviewer, media = [], rating, dateCreated } = review;
    
    let mediaHTML = '';
    if (media && media.length > 0) {
        mediaHTML = `
            <div class="review-media">
                ${media.map(item => {
                    if (item.type === 'image') {
                        return `
                            <div class="review-media-item-wrapper">
                                <a href="${item.imageUrls?.fullSizeUrl || item.fullSizeUrl || ''}" 
                                   class="review-media-item js-okeReviews-mediaStrip-item" 
                                   data-oke-ga-click-action="Review Photo Click" 
                                   role="button">
                                    <img src="${item.imageUrls?.fullSizeUrl || item.fullSizeUrl || ''}" 
                                         alt="Review media" 
                                         class="js-okeReviews-mediaStrip-media"
                                         data-oke-reviews-lazy-image-url="${item.imageUrls?.fullSizeUrl || item.fullSizeUrl || ''}"
                                         data-oke-reviews-media-id="${item.streamId || ''}"
                                         data-oke-reviews-mode="single">
                                </a>
                            </div>
                        `;
                    } else if (item.type === 'video') {
                        return `
                            <div class="review-media-item-wrapper">
                                <a href="${item.videoUrls?.fullSizeUrl || item.fullSizeUrl || ''}" 
                                   class="review-media-item review-media-video js-okeReviews-mediaStrip-item" 
                                   data-oke-ga-click-action="Review Video Click" 
                                   role="button">
                                    <div class="js-okeReviews-mediaStrip-media" 
                                         data-oke-reviews-media-id="${item.streamId || ''}"
                                         data-oke-reviews-mode="single"
                                         data-oke-reviews-lazy-image-url="${item.videoUrls?.videoPosterUrl || item.videoUrls?.thumbnailUrl || item.videoPosterURL || item.thumbnailUrl || ''}">
                                        <div class="video-poster">
                                            <img src="${item.videoUrls?.videoPosterUrl || item.videoUrls?.thumbnailUrl || item.videoPosterURL || item.thumbnailUrl || ''}" 
                                                 alt="Video thumbnail">
                                            <div class="play-button">▶</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        `;
                    }
                    return '';
                }).join('')}
            </div>
        `;
    }
    
    // Calculate AOS attributes
    const aosDelay = slideIndex * 150;
    const aosDuration = (slideIndex * 100) + 800;
    
    return `
        <div class="swiper-slide" data-aos="fade" data-aos-delay="${aosDelay}" data-aos-duration="${aosDuration}">
            <div class="review-item" 
                 data-review-rating="${rating || 5}" 
                 data-review-title="${title || ''}" 
                 data-review-date="${dateCreated || ''}"
                 data-truncate-length="${truncateLength}"
                         data-reviewer-avatar="${reviewer?.avatarUrl || ''}"
                         data-reviewer-location="${reviewer?.location ? JSON.stringify(reviewer.location) : ''}"
                         data-reviewer-country="${reviewer?.country ? JSON.stringify(reviewer.country) : ''}"
                         data-reviewer-verified="${reviewer?.isVerified || false}"
                         data-reviewer-verified-status="${reviewer?.verifiedStatus || ''}"
                         data-product-name="${review.productName || ''}"
                         data-product-image="${review.productImageUrl || ''}"
                         data-product-url="${review.productUrl || ''}"
                         data-product-variant-id="${review.variantId || ''}"
                         data-review-id="${review.reviewId || ''}"
                         data-helpful-count="${review.helpfulCount || 0}"
                         data-unhelpful-count="${review.unhelpfulCount || 0}"
                         data-video-poster-url="${review.videoPosterUrl || ''}"
                         data-read-more-text="${readMoreText}"
                         data-read-less-text="${readLessText}">
                <div class="review-body">
                    <div class="review-title-content">
                        <p class="review-title">${title || ''}</p>
                    </div>
                    <div class="js-okeReviews-reviewContent">
                        ${body || 'No review content'}
                    </div>
                            ${body && body.length > truncateLength ? `
                                <button class="js-okeReviews-readMore okeReviews-readMore" style="display: none;">
                                    ${readMoreText}
                                </button>
                            ` : ''}
                </div>
                <div class="reviewer-name">— ${reviewer?.displayName || 'Anonymous'}</div>
                ${mediaHTML}
            </div>
        </div>
    `;
}





async function essanoGetProductReviewsHTML(subscriberId, productId, limit = 10, orderBy = 'has_media desc', title = 'Product Reviews', writeReviewText = 'Write Review', readMoreText = 'Read More', locale = 'en', headingText = '', writeReviewUrl = '', readLessText = 'Read Less', truncateLength = 140) {
    try {
        const api = essanoCreateOkendoApi(subscriberId);
        
        // Fetch reviews (media should be included in reviews data)
        const reviewsResponse = await api.getProductReviews(productId, {
            limit: limit,
            orderBy: orderBy,
            locale: locale
        });
        
        // Reviews are already sorted by API based on orderBy parameter
        // If orderBy is 'has_media desc', reviews with media will come first
        const reviewsWithMedia = reviewsResponse.reviews;
        
        
        // Create complete HTML directly
        let completeHTML;
        if (!reviewsWithMedia || reviewsWithMedia.length === 0) {
            completeHTML = `
                <div class="essano-reviews-container">
                    <div class="review-header">
                        ${headingText ? `<h3 class="review-title" data-aos="hero" data-aos-order="1">${headingText}</h3>` : ''}
                        <a target="_blank" href="${writeReviewUrl}" 
                           class="okeReviews-reviewsWidget-header-controls-writeReview js-okeReviews-writeReview okeReviews-button" 
                           data-oke-reviews-write-review-product-id="${productId}" data-aos="hero" data-aos-order="2">
                            ${writeReviewText}
                        </a>
                    </div>
                    <div class="essano-no-reviews">No reviews found</div>
                </div>
            `;
        } else {
                    const reviewsHTML = reviewsWithMedia.map((review, index) => essanoCreateReviewHTML(review, readMoreText, productId, writeReviewText, headingText, writeReviewUrl, readLessText, truncateLength, index)).join('');
            completeHTML = `
                <div class="essano-reviews-container">
                    <div class="review-header">
                        ${headingText ? `<h3 class="review-title" data-aos="hero" data-aos-order="1">${headingText}</h3>` : ''}
                        <a href="${writeReviewUrl}" 
                           class="okeReviews-reviewsWidget-header-controls-writeReview js-okeReviews-writeReview okeReviews-button" 
                           data-oke-reviews-write-review-product-id="${productId}" data-aos="hero" data-aos-order="2">
                            ${writeReviewText}
                        </a>
                    </div>
                    <div class="swiper essano-reviews-swiper">
                        <div class="swiper-wrapper">
                            ${reviewsHTML}
                        </div>
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-button-next"></div>
                    </div>
                </div>
            `;
        }
        
        return {
            reviews: reviewsWithMedia,
            completeHTML: completeHTML
        };
        
    } catch (error) {
        console.error('Error getting product reviews HTML:', error);
        throw error;
    }
    
}

// Initialize Swiper and Read More functionality
function essanoInitReviews() {
    // Wait for Swiper to be loaded (since it's loaded with defer)
    function initSwiper() {
        if (typeof Swiper !== 'undefined') {
            const $swiperElement = $('.essano-reviews-swiper');
            
            if ($swiperElement.length) {
                const swiper = new Swiper('.essano-reviews-swiper', {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    loop: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            }
        } else {
            setTimeout(initSwiper, 100);
        }
    }
    
    // Start trying to initialize Swiper
    initSwiper();
    
    // Handle read more functionality
    function handleReadMore() {
        $('.review-item').each(function() {
            const $reviewItem = $(this);
            
            // Only apply to carousel items, not modal items
            if ($reviewItem.closest('.okeReviews-modal').length > 0) {
                return;
            }
            
            const $reviewContent = $reviewItem.find('.js-okeReviews-reviewContent');
            const $readMoreBtn = $reviewItem.find('.js-okeReviews-readMore');
            
            if ($reviewContent.length && $readMoreBtn.length) {
                const originalText = $reviewContent.text();
                const truncateLength = parseInt($reviewItem.attr('data-truncate-length')) || 140;
                const truncatedText = originalText.substring(0, truncateLength) + '...';
                
                if (originalText.length > truncateLength) {
                    // Save original text for later use BEFORE changing content
                    $reviewContent.attr('data-original-text', originalText);
                    
                    // Create 2 wrappers - one for truncated, one for full
                    const truncatedWrapper = `<div class="js-okeReviews-truncatedWrapper">${truncatedText}</div>`;
                    const fullWrapper = `<div class="js-okeReviews-fullWrapper" style="display: none;">${originalText}</div>`;
                    $reviewContent.html(truncatedWrapper + fullWrapper);
                    
                    // Calculate heights
                    const $truncatedWrapper = $reviewContent.find('.js-okeReviews-truncatedWrapper');
                    const $fullWrapper = $reviewContent.find('.js-okeReviews-fullWrapper');
                    
                    const truncatedHeight = $truncatedWrapper.outerHeight();
                    $fullWrapper.show();
                    const fullHeight = $fullWrapper.outerHeight();
                    $fullWrapper.hide();
                    
                    // Store heights
                    $reviewItem.attr('data-truncated-height', truncatedHeight);
                    $reviewItem.attr('data-full-height', fullHeight);
                    
                    $readMoreBtn.show();
                    $reviewItem.addClass('okeReviews-contentCollapsed');
                }
            }
        });
    }
    
    // Initialize read more
    handleReadMore();
    
    
    
    function createMediaGalleryModal() {
        const modalId = 'media-gallery-review-modal';
        
        const modalTemplate = `
            <div id="${modalId}-wrapper" class="okeReviews okeReviews--theme js-okeReviews">
                <div id="${modalId}" class="okeReviews-modal" aria-hidden="true">
                    <div tabindex="-1" class="okeReviews-modal-overlay js-okeReviews-modal-overlay"></div>
                    <div class="okeReviews-modal-inner" data-oke-reviews-modal-out-of-bounds>
                        <div class="okeReviews-modal-dialog js-okeReviews-modal-dialog" role="dialog" aria-labelledby="${modalId}-title">
                            <h1 id="${modalId}-title" class="okeReviews-a11yText">User-Uploaded Media Gallery</h1>
                            <div class="js-okeReviews-modal-content" data-oke-ga-change-action="Media Dialog Scroll" role="document">
                                {{{content}}}
                            </div>
                            <button class="okeReviews-modal-dialog-close" type="button" data-oke-reviews-modal-hide aria-label="close this modal window">&times;</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
        
        // Remove existing modal if any
        const $existingModal = $('#' + modalId + '-wrapper');
        if ($existingModal.length) {
            $existingModal.remove();
        }
        
        // Insert modal HTML with empty content initially (like html.js)
        const modalHTML = modalTemplate.replace('{{{content}}}', '');
        $('body').append(modalHTML);
        
        const $modalWrapper = $('#' + modalId + '-wrapper');
        const $modal = $('#' + modalId);
        const $overlay = $modal.find('.js-okeReviews-modal-overlay');
        const $dialog = $modal.find('.js-okeReviews-modal-dialog');
        const $closeBtn = $modal.find('.okeReviews-modal-dialog-close');
        const $hideButtons = $modal.find('[data-oke-reviews-modal-hide]');
        
        
        // Focus management like html.js
        const getFocusableElements = (container) => {
            const focusableSelectors = [
                'a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 
                'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 
                'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'
            ];
            const $elements = $(container).find(focusableSelectors.join(', '));
            return $elements.filter(function() {
                return !!(this.offsetWidth || this.offsetHeight || this.getClientRects().length);
            });
        };
        
        const focusFirstElement = (container) => {
            const $focusableElements = getFocusableElements(container);
            if ($focusableElements.length) {
                $focusableElements.first().focus();
            }
        };
        
        // Keyboard support like html.js
        const handleKeydown = (e) => {
            if (e.which === 27) { // ESC key
                e.preventDefault();
                closeModal();
            } else if (e.which === 9) { // Tab key
                const $focusableElements = getFocusableElements($modal[0]);
                const activeIndex = $focusableElements.index(document.activeElement);
                
                if (e.shiftKey && activeIndex === 0) {
                    $focusableElements.last().focus();
                    e.preventDefault();
                } else if (!e.shiftKey && activeIndex === $focusableElements.length - 1) {
                    $focusableElements.first().focus();
                    e.preventDefault();
                }
            }
        };
        
        // Focus trap like html.js
        const handleFocus = (e) => {
            if (!$modal[0].contains(e.target)) {
                focusFirstElement($modal[0]);
            }
        };
        
        // Modal functions with animation support like html.js
        let isAnimating = false;
        
        const open = () => {
            return new Promise((resolve, reject) => {
                if (isAnimating) return resolve();
                
                isAnimating = true;
                $modal.attr('aria-hidden', 'false');
                $('body').addClass('is-okeReviews-modalOpen');
                
                // Simple animation (fallback if no animate support)
                if (!$('body')[0].animate) {
                    $modalWrapper.show();
                    $modal.focus();
                    isAnimating = false;
                    resolve();
                    return;
                }
                
                // Animation like html.js
                const overlayAnimation = $overlay[0].animate([
                    { opacity: '0' },
                    { opacity: '1' }
                ], {
                    fill: 'forwards',
                    duration: 300,
                    easing: 'ease'
                });
                
                const dialogAnimation = $dialog[0].animate([
                    { transform: 'translateY(20px)', opacity: '0' },
                    { transform: 'translateY(0)', opacity: '1' }
                ], {
                    fill: 'forwards',
                    duration: 300,
                    easing: 'ease'
                });
                
                Promise.all([overlayAnimation.finished, dialogAnimation.finished])
                    .then(() => {
                        $('body').on('focus', handleFocus, true);
                        $(document).on('keydown', handleKeydown);
                        focusFirstElement($modal[0]);
                        isAnimating = false;
                        resolve();
                    })
                    .catch(() => {
                        isAnimating = false;
                        reject();
                    });
            });
        };
        
        const close = () => {
            return new Promise((resolve, reject) => {
                if (isAnimating) return resolve();
                
                isAnimating = true;
                
                // Simple close (fallback if no animate support)
                if (!$('body')[0].animate) {
                    $modal.attr('aria-hidden', 'true');
                    $('body').removeClass('is-okeReviews-modalOpen');
                    $modalWrapper.remove();
                    isAnimating = false;
                    resolve();
                    return;
                }
                
                // Animation like html.js
                const overlayAnimation = $overlay[0].animate([
                    { opacity: '1' },
                    { opacity: '0' }
                ], {
                    fill: 'forwards',
                    duration: 300,
                    easing: 'ease'
                });
                
                const dialogAnimation = $dialog[0].animate([
                    { transform: 'translateY(0)', opacity: '1' },
                    { transform: 'translateY(20px)', opacity: '0' }
                ], {
                    fill: 'forwards',
                    duration: 300,
                    easing: 'ease'
                });
                
                Promise.all([overlayAnimation.finished, dialogAnimation.finished])
                    .then(() => {
                        $modal.attr('aria-hidden', 'true');
                        $('body').removeClass('is-okeReviews-modalOpen');
                        $('body').off('focus', handleFocus, true);
                        $(document).off('keydown', handleKeydown);
                        $modalWrapper.remove();
                        isAnimating = false;
                        resolve();
                    })
                    .catch(() => {
                        isAnimating = false;
                        reject();
                    });
            });
        };
        
        // Add closeModal() function like html.js
        const closeModal = () => {
            close().catch(() => {});
        };
        
        // Add hide() function like html.js
        const hide = () => {
            return close();
        };
        
        if ($closeBtn.length) {
            $closeBtn.on('click', closeModal);
        }
        
        $hideButtons.each(function() {
            $(this).on('click', closeModal);
        });
        
        // Add ESC key listener like html.js
        $(document).on('keydown', function(e) {
            if (e.which === 27) { // ESC key
                e.preventDefault();
                closeModal();
            }
        });
        
        // Add click outside modal listener like html.js
        const $modalInner = $modal.find('.okeReviews-modal-inner');
        $modalInner.on('click', function(e) {
            if (e.target === this) {
                closeModal();
            }
        });
        
        // Prevent event bubbling from dialog to modal-inner
        $dialog.on('click', function(e) {
            e.stopPropagation();
        });
        
        return { open, close, hide, closeModal };
    }
    
    // Open media modal like html.js
    function openMediaModal(mediaUrl, mediaType, reviewData = null) {
        const modal = createMediaGalleryModal();
        
        if (modal) {
            // Set modal content with structure like html.js
            const $modalContent = $('.js-okeReviews-modal-content');
            if ($modalContent.length) {
                
                // Format date
                const formatDate = (dateString) => {
                    if (!dateString) return 'Recently';
                    const date = new Date(dateString);
                    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
                };
                
                let reviewHTML = '';
                if (reviewData) {
                    const rating = reviewData.rating || 5;
                    const author = reviewData.reviewer?.displayName || 'Anonymous';
                    const date = formatDate(reviewData.dateCreated);
                    const title = reviewData.title || '';
                    const body = reviewData.body || '';
                    const reviewId = reviewData.reviewId || 'unknown';
                    const helpfulCount = reviewData.helpfulCount || 0;
                    const unhelpfulCount = reviewData.unhelpfulCount || 0;
                    const ratingPercentage = (rating / 5) * 100;
                    
                    const getInitials = (name) => {
                        return (name || "").split(" ").slice(0, 2).map(word => {
                            return word.substr(0, 1).toLocaleUpperCase();
                        }).join("");
                    };
                    
                    reviewHTML = `
                        <div class="okeReviews-review okeReviews-review--simple">
                            <div class="okeReviews-review-reviewer-profile js-okeReviews-reviewerProfile">
                                <div class="okeReviews-review-reviewer-profile-avatar">
                                    <div class="okeReviews-avatar okeReviews-avatar--reviewer">
                                        <div class="okeReviews-avatar-placeholder" aria-hidden="true">${getInitials(author)}</div>
                                        ${reviewData.reviewer?.avatarUrl ? `<img src="${reviewData.reviewer.avatarUrl}" alt="" class="okeReviews-avatar-image">` : ''}
                                    </div>
                                </div>
                                <div class="okeReviews-review-reviewer-profile-details">
                                    <div>
                                        <span class="okeReviews-review-reviewer-profile-name">${author}</span>
                                        ${reviewData.reviewer?.location ? `
                                            <span aria-hidden="true" class="okeReviews-review-reviewer-profile-country okeReviews-flag okeReviews-flag--${reviewData.reviewer.location.country?.code?.toLowerCase() || ''}" title="${reviewData.reviewer.location.country?.name || ''}" aria-hidden="true"></span>
                                            <span class="okeReviews-a11yText">Reviewed by ${author}, from ${reviewData.reviewer.location.country?.name || ''}</span>
                                        ` : reviewData.reviewer?.country ? `
                                            <span aria-hidden="true" class="okeReviews-review-reviewer-profile-country okeReviews-flag okeReviews-flag--${reviewData.reviewer.country.code?.toLowerCase() || ''}" title="${reviewData.reviewer.country.name || ''}" aria-hidden="true"></span>
                                            <span class="okeReviews-a11yText">Reviewed by ${author}, from ${reviewData.reviewer.country.name || ''}</span>
                                        ` : `
                                            <span class="okeReviews-a11yText">Reviewed by ${author}</span>
                                        `}
                                    </div>
                                    ${reviewData.reviewer?.isVerified ? `
                                        <div class="okeReviews-review-reviewer-profile-status okeReviews-review-reviewer-profile-status--verified">
                                            ${reviewData.reviewer.verifiedStatus || 'Verified Buyer'}
                                        </div>
                                    ` : ''}
                                </div>
                            </div>
                            ${reviewData.productName ? `
                                <div class="okeReviews-review-reviewer-product">
                                    ${reviewData.productImageUrl ? `
                                        ${reviewData.productUrl ? `
                                            <a href="${reviewData.productUrl}${reviewData.variantId ? '?variant=' + reviewData.variantId : ''}" class="okeReviews-review-reviewer-product-thumbnail" data-oke-ga-beacon-click-action="Media Dialog Product Click">
                                                <img src="${reviewData.productImageUrl}" alt="${reviewData.productName}" class="okeReviews-review-reviewer-product-thumbnail-image">
                                            </a>
                                        ` : `
                                            <div class="okeReviews-review-reviewer-product-thumbnail">
                                                <img src="${reviewData.productImageUrl}" alt="${reviewData.productName}" class="okeReviews-review-reviewer-product-thumbnail-image">
                                            </div>
                                        `}
                                    ` : ''}
                                    <div class="okeReviews-review-reviewer-product-details">
                                        <div class="okeReviews-review-reviewer-product-details-heading">Reviewing</div>
                                        ${reviewData.productUrl ? `
                                            <a href="${reviewData.productUrl}${reviewData.variantId ? '?variant=' + reviewData.variantId : ''}" class="okeReviews-review-reviewer-product-details-link" data-oke-ga-beacon-click-action="Media Dialog Product Click">
                                                ${reviewData.productName}
                                            </a>
                                        ` : `
                                            <div>${reviewData.productName}</div>
                                        `}
                                    </div>
                                </div>
                            ` : ''}
                            <div class="okeReviews-review-meta js-okeReviews-reviewMeta">
                                <div class="okeReviews-review-date">
                                    <span class="okeReviews-a11yText">Review posted</span>
                                    <span data-oke-reviews-date="${reviewData.dateCreated || ''}">${date}</span>
                                </div>
                                <div class="okeReviews-review-starRating">
                                    <div class="okeReviews-starRating">
                                        <span class="okeReviews-a11yText">Rated ${rating} out of 5</span>
                                        <span class="okeReviews-starRating-indicator" role="presentation">
                                            <span class="okeReviews-starRating-indicator-layer"></span>
                                            <span class="okeReviews-starRating-indicator-layer okeReviews-starRating-indicator-layer--foreground" style="width: ${ratingPercentage}%;"></span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="okeReviews-review-main">
                                <h2 class="okeReviews-review-main-heading">${title}</h2>
                                <div class="okeReviews-review-main-content">
                                    <span class="js-okeReviews-reviewContent">${body}</span>
                                </div>
                            </div>
                            <div class="okeReviews-review-helpful js-okeReviews-reviewHelpful">
                                <span class="okeReviews-review-helpful-question">Was this helpful?</span>
                                <div class="okeReviews-review-helpful-vote">
                                    <button class="okeReviews-review-helpful-vote-button okeReviews-review-helpful-vote-button--positive js-okeReviews-review-helpful-vote-button" aria-label="Yes" aria-describedby="okeReviews-helpful-vote-counter-positive-${reviewId}" data-oke-reviews-vote="positive" data-oke-reviews-review-id="${reviewId}" data-oke-ga-click-action="Review Upvote">
                                        <span id="okeReviews-helpful-vote-counter-positive-${reviewId}" class="okeReviews-review-helpful-vote-counter">
                                            <span class="js-okeReviews-review-helpful-vote-counter-positive" data-oke-reviews-review-id="${reviewId}">${helpfulCount}</span>
                                            <span class="okeReviews-a11yText">${helpfulCount === 1 ? 'person voted yes' : 'people voted yes'}</span>
                                        </span>
                                    </button>
                                    <button class="okeReviews-review-helpful-vote-button okeReviews-review-helpful-vote-button--negative js-okeReviews-review-helpful-vote-button" aria-label="No" aria-describedby="okeReviews-helpful-vote-counter-negative-${reviewId}" data-oke-reviews-vote="negative" data-oke-reviews-review-id="${reviewId}" data-oke-ga-click-action="Review Downvote">
                                        <span id="okeReviews-helpful-vote-counter-negative-${reviewId}" class="okeReviews-review-helpful-vote-counter">
                                            <span class="js-okeReviews-review-helpful-vote-counter-negative" data-oke-reviews-review-id="${reviewId}">${unhelpfulCount}</span>
                                            <span class="okeReviews-a11yText">${unhelpfulCount === 1 ? 'person voted no' : 'people voted no'}</span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    `;
                } else {
                    // Generate initials for fallback
                    const getInitials = (name) => {
                        return (name || "").split(" ").slice(0, 2).map(word => {
                            return word.substr(0, 1).toLocaleUpperCase();
                        }).join("");
                    };
                    
                    reviewHTML = `
                        <div class="okeReviews-review okeReviews-review--simple">
                            <div class="okeReviews-review-reviewer-profile js-okeReviews-reviewerProfile">
                                <div class="okeReviews-review-reviewer-profile-avatar">
                                    <div class="okeReviews-avatar okeReviews-avatar--reviewer">
                                        <div class="okeReviews-avatar-placeholder" aria-hidden="true">${getInitials('Customer Review')}</div>
                                    </div>
                                </div>
                                <div class="okeReviews-review-reviewer-profile-details">
                                    <div>
                                        <span class="okeReviews-review-reviewer-profile-name">Customer Review</span>
                                        <span class="okeReviews-a11yText">Reviewed by Customer</span>
                                    </div>
                                </div>
                            </div>
                            <div class="okeReviews-review-meta js-okeReviews-reviewMeta">
                                <div class="okeReviews-review-date">
                                    <span class="okeReviews-a11yText">Review posted</span>
                                    <span data-oke-reviews-date="">Recently</span>
                                </div>
                                <div class="okeReviews-review-starRating">
                                    <div class="okeReviews-starRating">
                                        <span class="okeReviews-a11yText">Rated 5 out of 5</span>
                                        <span class="okeReviews-starRating-indicator" role="presentation">
                                            <span class="okeReviews-starRating-indicator-layer"></span>
                                            <span class="okeReviews-starRating-indicator-layer okeReviews-starRating-indicator-layer--foreground" style="width: 100%;"></span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="okeReviews-review-main">
                                <h2 class="okeReviews-review-main-heading">Customer Review</h2>
                                <div class="okeReviews-review-main-content">
                                    <span class="js-okeReviews-reviewContent">This is a customer review for the media you're viewing.</span>
                                </div>
                            </div>
                            <div class="okeReviews-review-helpful js-okeReviews-reviewHelpful">
                                <span class="okeReviews-review-helpful-question">Was this helpful?</span>
                                <div class="okeReviews-review-helpful-vote">
                                    <button class="okeReviews-review-helpful-vote-button okeReviews-review-helpful-vote-button--positive js-okeReviews-review-helpful-vote-button" aria-label="Yes" aria-describedby="okeReviews-helpful-vote-counter-positive-unknown" data-oke-reviews-vote="positive" data-oke-reviews-review-id="unknown" data-oke-ga-click-action="Review Upvote">
                                        <span id="okeReviews-helpful-vote-counter-positive-unknown" class="okeReviews-review-helpful-vote-counter">
                                            <span class="js-okeReviews-review-helpful-vote-counter-positive" data-oke-reviews-review-id="unknown">0</span>
                                            <span class="okeReviews-a11yText">people voted yes</span>
                                        </span>
                                    </button>
                                    <button class="okeReviews-review-helpful-vote-button okeReviews-review-helpful-vote-button--negative js-okeReviews-review-helpful-vote-button" aria-label="No" aria-describedby="okeReviews-helpful-vote-counter-negative-unknown" data-oke-reviews-vote="negative" data-oke-reviews-review-id="unknown" data-oke-ga-click-action="Review Downvote">
                                        <span id="okeReviews-helpful-vote-counter-negative-unknown" class="okeReviews-review-helpful-vote-counter">
                                            <span class="js-okeReviews-review-helpful-vote-counter-negative" data-oke-reviews-review-id="unknown">0</span>
                                            <span class="okeReviews-a11yText">people voted no</span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    `;
                }
                
                        const content = `
                            <div class="okeReviews-mediaGalleryReviewDialog">
                                <div class="okeReviews-mediaGalleryReviewDialog-main js-okeReviews-mediaGallery-main">
                                    <div class="okeReviews-mediaGalleryReviewDialog-slider">
                                        <div class="okeReviews-mediaGalleryReviewDialog-slider-inner">
                                            <div class="okeReviews-mediaSlider js-okeReviews-mediaSlider">
                                                <div class="okeReviews-mediaSlider-slide">
                                                    ${mediaType === 'video' 
                                                        ? `<video class="okeReviews-mediaSlider-slide-media okeReviews-mediaSlider-slide-media--video" width="100%" controls poster="${reviewData.videoPosterURL || reviewData.videoPosterUrl || ''}">
                                                            <source src="${mediaUrl}" type="video/mp4">
                                                            Your browser doesn't support HTML5 videos.
                                                        </video>`
                                                        : mediaType === 'instagram image'
                                                        ? `<div class="okeReviews-instagram-outerImageContainer">
                                                            <div class="okeReviews-instagram-imageContainer js-okeReviews-instagram-setTags">
                                                                <img class="okeReviews-instagram-media" src="${mediaUrl}" alt="Customer ${mediaType}">
                                                            </div>
                                                           </div>`
                                                        : mediaType === 'instagram video'
                                                        ? `<video class="okeReviews-mediaSlider-slide-media okeReviews-mediaSlider-slide-media--video" width="100%" controls poster="${reviewData.thumbnailUrl || ''}">
                                                            <source src="${mediaUrl}" type="video/mp4">
                                                            Your browser doesn't support HTML5 videos.
                                                        </video>`
                                                        : `<img class="okeReviews-mediaSlider-slide-media" src="${mediaUrl}" alt="Customer ${mediaType}">`
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="okeReviews-mediaGalleryReviewDialog-review">
                                        <div class="okeReviews-mediaGalleryReviewDialog-review-inner is-loading js-okeReviews-mediaSlider-review">
                                        </div>
                                    </div>
                                </div>
                                <div class="okeReviews-mediaGalleryReviewDialog-errorOverlay or-u-disNon js-okeReviews-mediaGallery-errorOverlay">
                                    <div class="okeReviews-mediaGalleryReviewDialog-errorOverlay-inner">
                                        <div class="okeReviews-mediaGalleryReviewDialog-errorOverlay-img"></div>
                                        <div class="okeReviews-mediaGalleryReviewDialog-errorOverlay-msg js-okeReviews-mediaGallery-errorOverlayMsg"></div>
                                        <button class="okeReviews-button js-okeReviews-mediaGallery-errorOverlayRetry">Retry</button>
                                    </div>
                                </div>
                            </div>
                        `;
                
                $modalContent.html(content);
                
                const $reviewContainer = $('.js-okeReviews-mediaSlider-review');
                if ($reviewContainer.length && reviewHTML) {
                    // Add loading state initially
                    $reviewContainer.addClass('is-loading');
                    
                    // Populate content
                    $reviewContainer.html(reviewHTML);
                    
                    // Remove loading state with animation like html.js
                    setTimeout(() => {
                        $reviewContainer.removeClass('is-loading');
                        
                        // Initialize helpful votes for the new content
                        handleHelpfulVotes();
                        
                        // Initialize date formatting for the new content
                        handleDateFormatting();
                    }, 100);
                }
            }
            
            // Open modal
            modal.open();
        } else {
            // Fallback: open in new tab
            window.open(mediaUrl, '_blank');
        }
    }
    
    function handleMediaClicks() {
        const $reviewsContainer = $('.essano-reviews-container');
        
        if ($reviewsContainer.length) {
            // Add event listener to reviews container like html.js does
            $reviewsContainer.on('click', function(e) {
                const $target = $(e.target);
                
                if ($target.hasClass('js-okeReviews-mediaStrip-media') || 
                    $target.hasClass('js-okeReviews-mediaStrip-item')) {
                    
                    e.preventDefault();
                    if ($target.hasClass('js-okeReviews-mediaStrip-media')) {
                        $target.parent().focus();
                    }
                    
                    const $mediaElement = $target.hasClass('js-okeReviews-mediaStrip-media') 
                        ? $target 
                        : $target.find('.js-okeReviews-mediaStrip-media');
                    
                    if ($mediaElement.length) {
                        const mediaId = $mediaElement.attr('data-oke-reviews-media-id');
                        
                        const getMode = (element) => {
                            if (!element.attr('data-oke-reviews-mode')) {
                                return 'single';
                            }
                            if (element.attr('data-oke-reviews-mode') === 'aggregate') {
                                return 'aggregate';
                            }
                            return 'single';
                        };
                        
                        const mode = getMode($mediaElement);
                        
                        // Find the review item to get review data
                        const $reviewItem = $target.closest('.review-item');
                        let reviewData = null;
                        
                        if ($reviewItem.length) {
                            // Extract review data from the review item
                            const $reviewBody = $reviewItem.find('.js-okeReviews-reviewContent');
                            const $reviewerName = $reviewItem.find('.reviewer-name');
                            const rating = $reviewItem.attr('data-review-rating');
                            const title = $reviewItem.attr('data-review-title');
                            const dateCreated = $reviewItem.attr('data-review-date');
                            
                            reviewData = {
                                rating: rating ? parseInt(rating) : 5,
                                reviewer: {
                                    displayName: $reviewerName.length ? $reviewerName.text().replace('— ', '') : 'Anonymous',
                                    avatarUrl: $reviewItem.attr('data-reviewer-avatar') || null,
                                    location: $reviewItem.attr('data-reviewer-location') ? JSON.parse($reviewItem.attr('data-reviewer-location')) : null,
                                    country: $reviewItem.attr('data-reviewer-country') ? JSON.parse($reviewItem.attr('data-reviewer-country')) : null,
                                    isVerified: $reviewItem.attr('data-reviewer-verified') === 'true',
                                    verifiedStatus: $reviewItem.attr('data-reviewer-verified-status') || null
                                },
                                dateCreated: dateCreated || null,
                                title: title || '',
                                body: $reviewBody.length ? ($reviewBody.attr('data-original-text') || $reviewBody.text()) : '',
                                productName: $reviewItem.attr('data-product-name') || null,
                                productImageUrl: $reviewItem.attr('data-product-image') || null,
                                productUrl: $reviewItem.attr('data-product-url') || null,
                                variantId: $reviewItem.attr('data-product-variant-id') || null,
                                reviewId: $reviewItem.attr('data-review-id') || 'unknown',
                                helpfulCount: parseInt($reviewItem.attr('data-helpful-count')) || 0,
                                unhelpfulCount: parseInt($reviewItem.attr('data-unhelpful-count')) || 0,
                                videoPosterUrl: $reviewItem.attr('data-video-poster-url') || null
                            };
                        }
                        
                        // Handle based on mode (like html.js)
                        if (mode === 'aggregate') {
                            // For aggregate mode, we'll use simple modal for now
                            const $mediaItem = $target.closest('.js-okeReviews-mediaStrip-item');
                            if ($mediaItem.length) {
                                const href = $mediaItem.attr('href');
                                if (href) {
                                    openMediaModal(href, 'image', reviewData);
                                }
                            }
                        } else {
                            const $mediaItem = $target.closest('.js-okeReviews-mediaStrip-item');
                            if ($mediaItem.length) {
                                const href = $mediaItem.attr('href');
                                const mediaType = $mediaElement.attr('data-oke-reviews-media-type') || 'image';
                                
                                if (href) {
                                    openMediaModal(href, mediaType, reviewData);
                                }
                            }
                        }
                    }
                }
            });
            
            // Add keyboard support like html.js
            $reviewsContainer.on('keydown', function(e) {
                if (e.keyCode === 32) { // Space key
                    const $target = $(e.target);
                    
                    if ($target.hasClass('js-okeReviews-mediaStrip-item') || 
                        $target.hasClass('js-okeReviews-mediaStrip-media')) {
                        
                        e.preventDefault();
                        
                        // Trigger click event
                        $target.trigger('click');
                    }
                }
            });
        }
    }
    
    // Initialize media clicks
    handleMediaClicks();
    
    // Initialize helpful vote functionality like html.js
    function handleHelpfulVotes() {
        const $reviewsContainer = $('.essano-reviews-container');
        
        if ($reviewsContainer.length) {
            // Add event listener for helpful vote buttons
            $reviewsContainer.on('click', function(e) {
                const $target = $(e.target);
                
                // Check if clicked element is a helpful vote button
                if ($target.hasClass('js-okeReviews-review-helpful-vote-button')) {
                    e.preventDefault();
                    
                    const voteType = $target.attr('data-oke-reviews-vote');
                    const reviewId = $target.attr('data-oke-reviews-review-id');
                    
                    if (voteType && reviewId) {
                        // Add loading state
                        $target.addClass('is-okeReviews-loading');
                        
                        // Simulate vote (in real implementation, this would call API)
                        setTimeout(() => {
                            const $counter = $target.find(`.js-okeReviews-review-helpful-vote-counter-${voteType}`);
                            if ($counter.length) {
                                const currentCount = parseInt($counter.text()) || 0;
                                $counter.text(currentCount + 1);
                            }
                            
                            // Remove loading state
                            $target.removeClass('is-okeReviews-loading');
                            
                            // Add voted state
                            $target.addClass('is-okeReviews-voted');
                            $target.attr('aria-pressed', 'true');
                        }, 500);
                    }
                }
            });
        }
    }
    
    // Initialize helpful votes
    handleHelpfulVotes();
    
    // Initialize date formatting like html.js
    function handleDateFormatting() {
        $('[data-oke-reviews-date]').each(function() {
            const $element = $(this);
            const dateString = $element.attr('data-oke-reviews-date');
            if (dateString) {
                const date = new Date(dateString);
                const formattedDate = date.toLocaleDateString('en-US', { 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric' 
                });
                $element.text(formattedDate);
            }
        });
    }
    
    // Initialize date formatting
    handleDateFormatting();
    
    // Initialize aria attributes management like html.js
    function handleAriaAttributes() {
        const $reviewsContainer = $('.essano-reviews-container');
        
        if ($reviewsContainer.length) {
            // Add event listener for expandable content
            $reviewsContainer.on('click', function(e) {
                const $target = $(e.target);
                
                // Check if clicked element is a read more button
                if ($target.hasClass('js-okeReviews-readMore')) {
                    const $reviewItem = $target.closest('.review-item');
                    const $reviewContent = $reviewItem.find('.js-okeReviews-reviewContent');
                    
                    if ($reviewItem.length && $reviewContent.length) {
                        const isExpanded = $reviewItem.hasClass('okeReviews-contentExpanded');
                        
                        if (isExpanded) {
                            // Collapse content - transition from full height to truncated height
                            const truncatedHeight = $reviewItem.attr('data-truncated-height');
                            const fullHeight = $reviewItem.attr('data-full-height');
                            
                            // Animate from full height to truncated height
                            $reviewContent.animate({
                                height: truncatedHeight + 'px'
                            }, 300, function() {
                                // Switch content after animation
                                $reviewContent.find('.js-okeReviews-fullWrapper').hide();
                                $reviewContent.find('.js-okeReviews-truncatedWrapper').show();
                                
                                $reviewItem.removeClass('okeReviews-contentExpanded');
                                $reviewItem.addClass('okeReviews-contentCollapsed');
                                $reviewContent.attr('aria-hidden', 'true');
                                $target.text($reviewItem.attr('data-read-more-text') || 'Read More');
                            });
                        } else {
                            // Expand content - transition from truncated height to full height
                            const truncatedHeight = $reviewItem.attr('data-truncated-height');
                            const fullHeight = $reviewItem.attr('data-full-height');
                            
                            // Animate from truncated height to full height
                            $reviewContent.animate({
                                height: fullHeight + 'px'
                            }, 300, function() {
                                // Switch content after animation
                                $reviewContent.find('.js-okeReviews-truncatedWrapper').hide();
                                $reviewContent.find('.js-okeReviews-fullWrapper').show();
                                
                                $reviewItem.addClass('okeReviews-contentExpanded');
                                $reviewItem.removeClass('okeReviews-contentCollapsed');
                                $reviewContent.attr('aria-hidden', 'false');
                                $target.text($reviewItem.attr('data-read-less-text') || 'Read Less');
                            });
                        }
                    }
                }
            });
        }
    }
    
    // Initialize aria attributes
    handleAriaAttributes();
    
    // Add smooth slideUp/slideDown transition for Read More
    function addReadMoreTransitions() {
        $('<style>').text(`
            .okeReviews-readMore {
                transition: all 0.3s ease;
                transform: translateY(0);
            }
            .js-okeReviews-reviewContent {
                overflow: hidden;
                word-wrap: break-word;
            }
            .js-okeReviews-truncatedWrapper {
                display: block;
            }
            .js-okeReviews-fullWrapper {
                display: none;
            }
            .review-item.okeReviews-contentCollapsed .js-okeReviews-reviewContent {
                display: block;
            }
            .review-item.okeReviews-contentExpanded .js-okeReviews-reviewContent {
                display: block;
            }
        `).appendTo('head');
    }
    
    // Initialize smooth transitions
    addReadMoreTransitions();
    
    // Handle resize to update collapsed heights
    function handleResize() {
        let resizeTimeout;
        $(window).on('resize', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                // Recalculate collapsed heights for all review items
                $('.review-item').each(function() {
                    const $reviewItem = $(this);
                    const $reviewContent = $reviewItem.find('.js-okeReviews-reviewContent');
                    const $truncatedWrapper = $reviewContent.find('.js-okeReviews-truncatedWrapper');
                    const $fullWrapper = $reviewContent.find('.js-okeReviews-fullWrapper');
                    const originalText = $reviewContent.attr('data-original-text');
                    
                    if (originalText && $reviewContent.length && $truncatedWrapper.length && $fullWrapper.length) {
                        // Store current state
                        const isExpanded = $reviewItem.hasClass('okeReviews-contentExpanded');
                        
                        // Update truncated content
                        const truncateLength = parseInt($reviewItem.attr('data-truncate-length')) || 140;
                        const truncatedText = originalText.substring(0, truncateLength) + '...';
                        $truncatedWrapper.html(truncatedText);
                        
                        // Update full content
                        $fullWrapper.html(originalText);
                        
                        // Restore to original state
                        if (isExpanded) {
                            $truncatedWrapper.hide();
                            $fullWrapper.show();
                        } else {
                            $truncatedWrapper.show();
                            $fullWrapper.hide();
                        }
                    }
                });
            }, 250); // Debounce resize events
        });
    }
    
    // Initialize resize handler
    handleResize();
    
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        essanoCreateOkendoApi,
        essanoGetProductReviewsHTML,
        essanoCreateReviewHTML,
        essanoInitReviews
    };
}

